import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirdicab() {



  const cardData =
  {
    keyword: 'Pune to Shirdi Cab',
    heading: 'Aaryan Travels: Pune to Shirdi Cab',
    headingDescription: ' Aaryan Travels provides convenient Pune to Shirdi Cab services for devotees traveling to the holy Sai Baba Temple. Whether you’re planning a same-day darshan trip or a relaxed family journey, our clean and comfortable sedans, SUVs, and tempo travellers ensure a pleasant ride across the Pune–Shirdi route. With experienced chauffeurs, timely departures, and doorstep pickup from anywhere in Pune—including Pune Airport, Kothrud, Wakad, Wagholi, and Hadapsar—we make your pilgrimage smooth and stress-free. Choose from one-way or round-trip cab bookings with transparent fares and 24/7 availability. For a safe, affordable, and peaceful journey to Shirdi, trust Aaryan Travels as your travel partner.',

    top: 'Top Places to Visit in Shirdi with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shirdi Sai Baba Temple",
    "description": "The Shirdi Sai Baba Temple is the main pilgrimage site dedicated to the revered saint Sai Baba, attracting millions of devotees annually. The temple complex includes the Samadhi Mandir where Sai Baba’s mortal remains are preserved. Aarti ceremonies held four times a day create a deeply spiritual atmosphere. Devotees stand in long queues with utmost devotion and faith. The temple is the heart and soul of Shirdi’s divine aura."
  },
  {
    "title": "Dwarkamai Masjid",
    "description": "Dwarkamai Masjid is where Sai Baba spent a major part of his life, offering solace and guidance to his followers. The sacred dhuni (fire) that Baba lit is still kept burning and its ashes are believed to have healing powers. The simple stone structure radiates peace and humility. People sit quietly, absorbing the spiritual energy. Dwarkamai is Shirdi’s symbol of compassion and unity."
  },
  {
    "title": "Gurusthan",
    "description": "Gurusthan, meaning ‘Seat of the Guru’, is the place where Sai Baba was first seen as a young ascetic, sitting under a neem tree. A shrine with a sacred idol and incense burners now marks this holy location. Devotees believe lighting incense sticks here fulfills wishes. The surrounding neem leaves are considered prasad. Gurusthan is Shirdi’s earliest mark of Sai Baba’s presence."
  },
  {
    "title": "Chavadi",
    "description": "Chavadi is the place where Sai Baba rested on alternate nights during his later years. Today, it holds a ceremonial significance as the Palanquin Procession (Palkhi) of Sai Baba’s idol starts from Dwarkamai and reaches here every Thursday. The interior houses Baba’s bedding, wooden seat, and photographs. Chavadi keeps alive the rituals practiced during his lifetime. It is Shirdi’s sacred heritage corner."
  },
  {
    "title": "Shani Shingnapur Temple",
    "description": "Located around 70 km from Shirdi, Shani Shingnapur Temple is dedicated to Lord Shani (Saturn). The unique feature of this village is that no home has doors or locks, as people believe Lord Shani protects them from theft and harm. The open-air shrine with a large black stone idol attracts devotees seeking relief from obstacles and misfortune. Shani Shingnapur is Shirdi’s powerful spiritual excursion."
  },
  {
    "title": "Sai Heritage Village and Theme Park",
    "description": "Sai Heritage Village is a creative theme park that depicts various scenes from Sai Baba’s life through life-sized statues and artistic installations. Kids enjoy ropeways, rides, and adventure zones, while elders appreciate the devotional atmosphere. The rural setting adds authenticity to the storytelling. It blends spirituality with recreation. Sai Heritage Village is Shirdi’s engaging family attraction."
  },
  {
    "title": "Lendi Baug",
    "description": "Lendi Baug is a serene garden where Sai Baba used to water plants and spend quiet moments in meditation. A lamp lit by Baba still burns inside a small shrine called Nanda Deep. The refreshing greenery and flower beds create a calming environment. Visitors walk through the peaceful pathways reflecting on Baba’s humble lifestyle. Lendi Baug is Shirdi’s tranquil spiritual garden."
  },
  {
    "title": "Khandoba Temple",
    "description": "Khandoba Temple is believed to be the place where Sai Baba first entered Shirdi and was welcomed by a local priest named Mhalsapati with the words ‘Aao Sai’. Dedicated to Lord Khandoba, a form of Shiva, the temple holds immense historical importance. Pilgrims visit to honor the moment Baba was first recognized as a saint. Khandoba Temple is Shirdi’s welcoming point of divine arrival."
  },
  {
    "title": "Wet N Joy Water Park",
    "description": "Wet N Joy Water Park offers a refreshing break from the spiritual tour with thrilling water rides, wave pools, and rain dance setups. Families and children enjoy a full day of fun and excitement. Clean facilities and multiple food courts make it comfortable for all age groups. It provides entertainment amid devotion. Wet N Joy is Shirdi’s joyful recreational escape."
  },
  {
    "title": "Prasadalaya",
    "description": "Prasadalaya is the massive dining hall run by the Shirdi Sansthan, where thousands of devotees are served free or low-cost meals daily. The system is highly organized, offering simple yet wholesome meals prepared with utmost hygiene. Eating together with people from all walks of life symbolizes unity and equality. Prasadalaya is Shirdi’s embodiment of community service."
  }
],


"services": [
  {
    "name": "Pune to Shirdi Cab",
    "description": "Travel comfortably from Pune to Shirdi with our dedicated cab service. Offering a range of vehicles and professional drivers, this service ensures timely pickups, safe journeys, and convenient travel schedules. Ideal for pilgrims, tourists, and business travelers looking for reliable transportation to Shirdi."
  },
  {
    "name": "Cab from Pune to Shirdi",
    "description": "Our Cab from Pune to Shirdi service provides affordable and hassle-free transportation options for individuals and groups. Choose from sedans, SUVs, and premium cars, all maintained to the highest standards, driven by experienced chauffeurs familiar with the route and local traffic conditions."
  },
  {
    "name": "Taxi Pune Shirdi",
    "description": "Experience efficient Taxi services from Pune to Shirdi with well-trained drivers and a variety of vehicle options. Whether for a day trip or extended travel, our taxi service offers flexible timing, competitive pricing, and exceptional customer care to ensure a smooth journey."
  },
  {
    "name": "Outstation Cab Pune Shirdi",
    "description": "Opt for our Outstation Cab service from Pune to Shirdi for long-distance travel with comfort and reliability. Vehicles are air-conditioned and well-equipped, while drivers are professional and knowledgeable about the best routes for a timely trip."
  },
  {
    "name": "Pune to Shirdi Chauffeur",
    "description": "Travel in style with a dedicated chauffeur service from Pune to Shirdi. Enjoy personalized attention, punctual pickups, and a seamless travel experience. Our chauffeurs are courteous, experienced, and well-versed with local roads to ensure your comfort and safety."
  },
  {
    "name": "Pune to Shirdi Sedan Cab",
    "description": "Our Sedan Cab service from Pune to Shirdi offers a smooth and comfortable ride, perfect for small groups or solo travelers. Sedans are air-conditioned, spacious, and maintained to offer a premium travel experience."
  },
  {
    "name": "Pune to Shirdi SUV Hire",
    "description": "Hire SUVs for your Pune to Shirdi journey when you need extra space and comfort. Ideal for families or groups, our SUVs come with ample luggage space, air-conditioning, and experienced drivers to make your trip pleasant and safe."
  },
  {
    "name": "Affordable Cab Pune Shirdi",
    "description": "Get budget-friendly cab services from Pune to Shirdi without compromising on quality or comfort. Our affordable cabs are ideal for daily commuters, pilgrims, and tourists looking for economical yet reliable transportation."
  },
  {
    "name": "Cab Hire Pune to Shirdi",
    "description": "Book cab hire services for your Pune to Shirdi trip with flexible options ranging from hourly to full-day rentals. Choose your preferred vehicle type and enjoy professional service with well-maintained cars and courteous drivers."
  },
  {
    "name": "Online Cab Booking Pune Shirdi",
    "description": "Conveniently book your Pune to Shirdi cab online with instant confirmation, secure payments, and flexible scheduling. Our digital platform simplifies your travel planning and ensures a smooth booking experience."
  },
  {
    "name": "Best Cab Pune Shirdi",
    "description": "Experience the best cab service from Pune to Shirdi with our premium fleet and highly rated drivers. We prioritize customer satisfaction through timely pickups, clean vehicles, and competitive pricing."
  },
  {
    "name": "One Way Cab Pune to Shirdi",
    "description": "Choose our One Way Cab service from Pune to Shirdi for quick, affordable, and comfortable single-direction travel. Ideal for pilgrims and tourists looking for a hassle-free trip without return commitments."
  },
  {
    "name": "Round Trip Taxi Pune Shirdi",
    "description": "Plan your complete Pune to Shirdi journey with our Round Trip Taxi service offering seamless travel to and from Shirdi. Enjoy discounted round-trip rates, professional drivers, and reliable vehicle availability."
  },
  {
    "name": "Shirdi Tour from Pune",
    "description": "Make the most of your spiritual trip with our Shirdi Tour service from Pune. Customized tour packages include transportation, local sightseeing, and comfortable stops, ensuring a memorable and hassle-free pilgrimage."
  },
  {
    "name": "Fast Cab Pune to Shirdi",
    "description": "Need to reach Shirdi quickly? Our Fast Cab service from Pune offers swift pickups and optimized routes to get you there on time without compromising comfort or safety. Perfect for urgent travel and tight schedules."
  }
],
"tableData": [
  ["Pune to Shirdi Cab", "Cab from Pune to Shirdi"],
  ["Taxi Pune Shirdi", "Outstation Cab Pune Shirdi"],
  ["Pune to Shirdi Chauffeur", "Pune to Shirdi Sedan Cab"],
  ["Pune to Shirdi SUV Hire", "Affordable Cab Pune Shirdi"],
  ["Cab Hire Pune to Shirdi", "Online Cab Booking Pune Shirdi"],
  ["Best Cab Pune Shirdi", "One Way Cab Pune to Shirdi"],
  ["Round Trip Taxi Pune Shirdi", "Shirdi Tour from Pune"],
  ["Fast Cab Pune to Shirdi", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Pune to Shirdi Cab Service",
    "WhyChoosedescription": "Aaryan Travels provides reliable and comfortable cab services for your Pune to Shirdi journey."
  },
  {
    "WhyChooseheading": "Prompt Pickup from Anywhere in Pune",
    "WhyChoosedescription": "Our drivers ensure timely and convenient pickups to start your trip without any delays."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Your Journey",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained for your comfort and safety."
  },
  {
    "WhyChooseheading": "Experienced Drivers Well-Versed with Pune-Shirdi Routes",
    "WhyChoosedescription": "Our drivers know the best and fastest routes to make your journey smooth and efficient."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy transparent pricing that covers fuel, tolls, and driver allowances with no surprises."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our customer service team is available round the clock to assist with your booking and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Booking Options for One-Way and Round Trips",
    "WhyChoosedescription": "Choose from one-way or round-trip rides according to your travel plans."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options to Suit Your Group Size",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or tempo travellers based on your comfort and luggage needs."
  }
]





























  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide cab services from Pune to Shirdi?',
    answer: 'Yes, Aaryan Travels offers reliable and comfortable cab services for travel from Pune to Shirdi.',
  },
  {
    question: 'How can I book a cab from Pune to Shirdi with Aaryan Travels?',
    answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Pune to Shirdi cab services?',
    answer: 'Aaryan Travels offers a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Are cabs available for one-way and round trips between Pune and Shirdi?',
    answer: 'Yes, we provide both one-way and round-trip cab services between Pune and Shirdi.',
  },
  {
    question: 'Are the drivers experienced with the Pune to Shirdi route?',
    answer: 'Absolutely. Our drivers are licensed professionals familiar with the Pune-Shirdi route for a safe and comfortable journey.',
  },
  {
    question: 'Can I book hourly or full-day packages for Pune to Shirdi travel?',
    answer: 'Yes, we offer flexible hourly and full-day rental packages to accommodate your travel plans.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Shirdi cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety measures to ensure passenger safety.',
  },
  {
    question: 'Is Aaryan Travels cab service from Pune to Shirdi available 24x7?',
    answer: 'Yes, our cab services operate round the clock for Pune to Shirdi travel.',
  },
  {
    question: 'What payment options are accepted for Pune to Shirdi cab bookings?',
    answer: 'We accept cash, credit/debit cards, UPI, and digital wallets for smooth payments.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Pune to Shirdi cab bookings?',
    answer: 'Yes, Aaryan Travels allows you to specify your preferred pickup and drop points within Pune and Shirdi.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Kulkarni',
    feedback: 'Aaryan Travels provided excellent cab service from Pune to Shirdi. The driver was punctual and the ride was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Desai',
    feedback: 'Had a great experience booking a Pune to Shirdi cab with Aaryan Travels. Highly recommended!',
    rating: 5,
  },
];


















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Cab",
  "image": "https://aaryantravels.com/assets/images/pune-shirdi-cab.jpg", // replace with actual image URL
  "description": "Affordable and reliable Pune to Shirdi cab service offering sedan, SUV, and chauffeur-driven options. Book online for one-way or round trips and enjoy a comfortable journey with Aaryan Travels.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "4150", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/pune-to-shirdi-cab"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Shirdi Cab | Affordable & Reliable Taxi Service | Aaryan Travels</title>
  <meta
    name="description"
    content="Affordable and reliable Pune to Shirdi cab service offering sedan, SUV, and chauffeur-driven options. Book online for one-way or round trips and enjoy a comfortable journey with Aaryan Travels."
  />
  <meta
    name="keywords"
    content="Pune to Shirdi Cab, Cab from Pune to Shirdi, Taxi Pune Shirdi, Outstation Cab Pune Shirdi, Pune to Shirdi Chauffeur, Pune to Shirdi Sedan Cab, Pune to Shirdi SUV Hire, Affordable Cab Pune Shirdi, Cab Hire Pune to Shirdi, Online Cab Booking Pune Shirdi, Best Cab Pune Shirdi, One Way Cab Pune to Shirdi, Round Trip Taxi Pune Shirdi, Shirdi Tour from Pune, Fast Cab Pune to Shirdi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoshirdicab;